import React from "react";

import { ReactComponent as CaixaSegurosLogo } from "../../../../assets/images/logos/caixa-seguros-logo.svg";
import { ReactComponent as SasseLogo } from "../../../../assets/images/logos/sasse-logo.svg";
import { ReactComponent as CnpAssurancesLogo } from "../../../../assets/images/logos/cnp-assurances-logo.svg";
import { ReactComponent as CaixaSegurosSaudeLogo } from "../../../../assets/images/logos/caixa-seguros-saude-logo.svg";
import { ReactComponent as CaixaSeguradoraLogo } from "../../../../assets/images/logos/caixa-seguradora-logo.svg";
import { ReactComponent as YouseLogo } from "../../../../assets/images/logos/youse-logo.svg";
import { ReactComponent as CnpSegurosHoldingLogo } from "../../../../assets/images/logos/cnp-seguros-holding-logo.svg";

import * as S from "./AboutUsSection.style";

export const stepList = [
  {
    id: 1,
    title: "1967 | O início como Sasse",
    classNameCircle: "secondary",
    image: SasseLogo,
    description: (
      <>
        Em 22 de maio, começamos a atuar no mercado de seguros como Sasse —
        Companhia Nacional de Seguros Gerais. Nessa época, nossas acionistas
        eram a Fundação dos Economiários Federais (Funcef) e a{" "}
        <strong>Caixa Econômica Federal</strong>, o maior banco público da
        América Latina.
      </>
    ),
  },
  {
    id: 2,
    title: "2000 | Mudamos o nome",
    image: CaixaSegurosLogo,
    description: (
      <>
        Passamos a ser <strong>Caixa Seguros</strong>, fortalecendo nossa
        presença no mercado.
      </>
    ),
  },
  {
    id: 3,
    title: "2001 | Caixa Seguros integra grupo francês",
    image: CnpAssurancesLogo,
    description: (
      <>
        Passamos por uma grande transformação, quando a{" "}
        <strong>CNP Assurances</strong> assumiu, em parceria com a Caixa, o
        comando da Caixa Seguros.
      </>
    ),
  },
  {
    id: 4,
    title: "2011 | Nasce a Caixa Seguros Saúde",
    image: CaixaSegurosSaudeLogo,
    description: (
      <>
        Ampliamos nosso ecossistema com a criação da{" "}
        <strong>Caixa Seguros Saúde</strong>.
      </>
    ),
  },
  {
    id: 5,
    title: "2014 | Novo nome e marca",
    image: CaixaSeguradoraLogo,
    description: (
      <>
        Mudamos o nome para <strong>Caixa Seguradora</strong>, ainda mais
        focados em simplificar o acesso a produtos de seguridade no Brasil.
      </>
    ),
  },
  {
    id: 6,
    title: "2016 | Criamos a Youse",
    image: YouseLogo,
    description: (
      <>
        Lideramos uma iniciativa inédita no mercado brasileiro de seguros: o
        desenvolvimento da primeira plataforma 100% digital do Brasil, simples e
        acessível, focada no mercado securitário. Assim nasceu a{" "}
        <strong>Youse</strong>, que trouxe um novo jeito de vender seguros no
        País.
      </>
    ),
  },
  {
    id: 7,
    title: "2021 | Integrados à CSH",
    classNameCircle: "primary-dark",
    image: CnpSegurosHoldingLogo,
    description: (
      <>
        Junto à Youse, passamos a fazer parte da{" "}
        <strong>CNP Seguros Holding Brasil (CSH)</strong> que, hoje, cuida de
        mais de 4 milhões de clientes. Seguimos com a gestão dos seguros
        Habitacional, Residencial, Empresarial, Saúde e Auto. Para saber mais
        sobre a holding, empresas do grupo, reconhecimentos, publicações e
        outros assuntos,{" "}
        <a
          href="https://www.cshbrasil.com.br/"
          target="_blank"
          rel="noreferrer"
        >
          clique aqui
        </a>
        .
      </>
    ),
  },
];

export const AboutUsSection = () => {
  return (
    <S.AboutUsSectionContainer>
      <S.AboutUsSectionContent className="container">
        <S.AboutUsSectionTitle>
          Há 58 anos cuidamos de milhões de brasileiros e de suas conquistas.
          Confira nossa trajetória!
        </S.AboutUsSectionTitle>

        <S.AboutUsStepList>
          {stepList.map((stepItem, index) => {
            const isLastSteps = stepList.length === index + 1;

            return (
              <S.AboutUsStepItem key={stepItem.id} $isLastSteps={isLastSteps}>
                <S.AboutUsStepItemCircle
                  className={stepItem?.classNameCircle}
                />
                <S.AboutUsStepItemTitle>
                  {stepItem.title}
                </S.AboutUsStepItemTitle>

                <S.AboutUsStepItemContent>
                  <S.AboutUsStepItemImage>
                    <stepItem.image />
                  </S.AboutUsStepItemImage>

                  <S.AboutUsStepItemDescription>
                    {stepItem.description}
                  </S.AboutUsStepItemDescription>
                </S.AboutUsStepItemContent>
              </S.AboutUsStepItem>
            );
          })}
        </S.AboutUsStepList>
      </S.AboutUsSectionContent>
    </S.AboutUsSectionContainer>
  );
};
